import Color from "../../../data/Color";
import Flex from "../../../data/Flex";
import Size from "../../../data/Size";
import UIButton from "../../../ui/UIButton";
import UIContainer from "../../../ui/UIContainer";
import UIFlex from "../../../ui/UIFlex";
import UIIcon from "../../../ui/UIIcon";
import UITable, { ITableColumn, ITableSortDirectionType } from "../../../ui/UITable";
import FormatUtil from "../../../util/FormatUtil";
import './CallHistory.scss';
import Api from '../../../api/Api';
import { useEffect, useState } from 'react';
import { ICDRData, handleSetICDRData } from '../../../data/CDRData';
import { dispatch, listen, unlisten } from '../../../dispatcher/Dispatcher';
import AppEvent from '../../../events/AppEvent';
import useLoadingState from "../../../hooks/useLoadingState";
import { UILoadingState } from "../../../ui/UILoadingState";

export interface ICallHistoryProps {
    visible:boolean;

}

CallHistory.PATH = "call-history";

export function CallHistory($props:ICallHistoryProps){


    const [callHistoryLastRefresh, setLastRefresh] = useState<Date>(new Date());
    
    const [loadingState, setLoading, setError, setLoadingState, resetLoadingState] = useLoadingState({loading:true});
    
    const [data, setData] = useState<ICDRData[]>([]);

    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

    const zoneAbreviation = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];

    const loadData = () =>{
        setLoadingState({loading:true, error:undefined});
        Api.cdr.getCDRS(($success,$result)=>{
            setLastRefresh(new Date());
            if($success && $result.results){
                setLoadingState({loading:false, error:undefined});
                let data = handleSetICDRData($result.results);
                setData(data);
            }else{
                setLoadingState({loading:false, error:$result});
            }
        });
    }

    const selectedCDRId = ($cdrData:ICDRData) => {
        dispatch(AppEvent.VIEW_CDR_DETAILS,$cdrData);
    }

    
    useEffect(()=>{
        loadData();
    },[]);

    let arrColumns:ITableColumn[] = [
        {
            dataKey:"display",
            name:"Call Display",
            width:200,       
            flexGrow:1,     
        },
        {
            dataKey:"providerContactNumber",
            name:"Provider Contact",
            width:200,           
            flexGrow:1,          
        },
        {
            dataKey:"time",
            name:"Time",
            width:180,     
                   
        },
        {
            dataKey:"action",
            name:"Action",
            width:100,     
            dataGetter:($data)=>{
                return  (
                    <UIButton onClick={()=>{
                        selectedCDRId($data);
                    }} size={Size.s36} noPadding iconFontSize={Size.s24} icon={UIIcon.CHEVRON_RIGHT} isSquare/>


                );
            }       
        },
    ];

    const _sort=($sortBy:string, $direction:ITableSortDirectionType, $a:any, $b:any):number=>{
        let numRet:number;

        let strA:string = "";
        let strB:string = "";
       
        


        switch($sortBy){
            default:
                let dataA:any = $a;
                let dataB:any = $b;
                strA = dataA[$sortBy];
                strB = dataB[$sortBy];
        }

        numRet = UITable.BASIC_SORT($direction,strA,strB);

        return numRet;
    }    
    return (
        <div className={CallHistory.PATH+($props.visible?" visible":"")}>
            
            <UIFlex flex={{fullWidth:true, style:{marginBottom:20, flexShrink:0}}}>
                <UIFlex flex={{style:{flexGrow:1, paddingTop:10}}}>
                    Last refreshed: {FormatUtil.dateHMS(callHistoryLastRefresh,false,true,false,false)} on {FormatUtil.dateMDY(callHistoryLastRefresh,true,false,false)} {timeZone} {zoneAbreviation}
                    
                </UIFlex>
                <UIButton 
                dropShadow label="Refresh" icon={UIIcon.RELOAD} color={Color.TRANSPARENT_PRIMARY} flex={{style:{padding:10}, direction:Flex.ROW_REVERSE}} onClick={()=>{
                    loadData();
                }}/>
            </UIFlex>
            <UIContainer flex={{direction:Flex.COLUMN, style:{flexShrink:0}}} className="historyContainer">
                
                <UILoadingState loading={loadingState.loading} error={loadingState.error}>
                    <UITable

                        columns={arrColumns}
                        data={data}
                        sort={_sort}
                        sortEnabled={false}
                        rowRenderer={($data:any, $columns:JSX.Element, $className:string, $key:string, $index:number)=>{

                            let cnRow:string = "callHistoryRow "+$className;
                            return (
                                <div className={cnRow} key={$key+$index}>
                                    {$columns}
                                </div>
                            );
                        }}                    
                    />
                    {data.length===0 && (
                        <div className="noData">
                            No Results Available
                        </div>
                    )}
                </UILoadingState>
                
            </UIContainer>
        </div>
    );
}
